"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Popover: {
      position: 'relative',
      width: function width(_ref) {
        var props = _ref.props;
        return (props === null || props === void 0 ? void 0 : props.size) === 'large' ? 250 : 182;
      },
      borderRadius: 6,
      backgroundColor: theme['$popover-background'],
      color: theme['$popover-text-color'],
      fontSize: 12,
      fontFamily: theme['$font-default'],
      boxSizing: 'border-box'
    },
    Inner: {
      width: '100%',
      height: '100%',
      padding: 10,
      lineHeight: '1.42',
      boxSizing: 'border-box'
    },
    Content: {
      width: '100%',
      height: '100%',
      overflow: 'auto'
    },
    Title: {
      marginBottom: 20
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=Body.style.js.map